import Moment from 'moment';
import String from '@/utils/string.js';

export default {
    moment: Moment,
    string: String
}